<template>
  <div class="d-flex order_search_width">
    <v-container class="col-11 ml-0 mt-10 pl-0 pb-7">
      <v-row class="mb-4 ml-0 height50px" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          결제일
        </v-col>
        <v-col cols="4">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.paid_from"
                readonly
                v-on="on"
                dense
                class="d-inline-block mr-1 order_search_days_width"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.paid_from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.paid_to"
            ></v-date-picker> </v-menu
          >~
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.paid_to"
                readonly
                v-on="on"
                dense
                class="d-inline-block mr-1 order_search_days_width"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.paid_to"
              @input="endMenu = false"
              locale="ko"
              :min="searchPayload.paid_from"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="2" class="pb-0 pt-5 pl-0">
          상품명
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="searchPayload.product_no"
            :items="productItems"
            item-text="text"
            item-value="value"
            outlined
            dense
            class="mr-1 order_search_input_width_type2"
            hide-details
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0 height50px">주문번호</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            hide-details
            class="mr-1 order_search_input_width"
            placeholder="주문번호 입력"
            v-model="searchPayload.order_id"
            v-on:keyup.enter="execSearch()"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          주문자명
        </v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            hide-details
            class="mr-1 order_search_input_width_type2"
            placeholder="주문자명 입력"
            v-model="searchPayload.member_name"
            v-on:keyup.enter="execSearch()"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" class="pb-0 pt-5 pl-0 height50px">회원ID</v-col>
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            class="mr-1 order_search_input_width"
            placeholder="회원ID 입력"
            v-model="searchPayload.member_id"
            v-on:keyup.enter="execSearch()"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pb-0 pt-5 pl-0">
          휴대전화
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="searchPayload.member_phone"
            outlined
            dense
            class="mr-1 order_search_input_width_type2"
            placeholder="휴대전화 입력"
            v-on:keyup.enter="execSearch()"
            @keydown="M.replaceNumber($event, 15, false)"
            @keyup="M.replaceNumber($event, 15, false)"
          ></v-text-field>
        </v-col>
      </v-row>

      <div class="row justify-center mb-10">
        <v-btn
          large
          color="grey darken-4"
          class="white--text"
          width="100"
          @click="execSearch()"
          >조회</v-btn
        >
        <v-btn
          large
          style="margin-left: 20px;"
          width="100"
          @click.prevent="resetSearch"
          >초기화</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
let dayjs = require("dayjs");

import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import "@/assets/style/order.css";

export default {
  data() {
    return {
      M,
      modal: false,
      startMenu: false,
      endMenu: false,
      productItems: [{ text: "포인트상품 전체", value: "" }],
      searchPayload: {
        paid_from: "",
        paid_to: "",
        product_no: "",
        order_id: "",
        member_name: "",
        member_id: "",
        member_phone: "",
        limit: 50,
        offset: 0,
        page: 1,
      },
      total_count: 0,
    };
  },
  methods: {
    execSearch: function() {
      this.getOrderList();
    },
    getOrderList: async function() {
      try {
        let result = await M.api(
          M.entry("/get/mileage/orders"),
          this.searchPayload
        );
        this.total_count = result.count;
        let pagein_count =
          Number(this.total_count) / Number(this.searchPayload.limit);
        this.$parent.$refs.OrderList.pageCount = Math.ceil(pagein_count);
        this.$parent.$refs.OrderList.setOrderList(result);
      } catch (e) {
        alert("주문목록 조회 실패했습니다");
      }
    },
    resetSearch: function() {
      //Object.assign(this.$data, this.$options.data());

      const today = dayjs();
      this.searchPayload.paid_from = today
        .subtract("1", "month")
        .format("YYYY-MM-DD");
      this.searchPayload.paid_to = today.format("YYYY-MM-DD");

      this.searchPayload = {
        paid_from: today.subtract("1", "month").format("YYYY-MM-DD"),
        paid_to: today.format("YYYY-MM-DD"),
        product_no: "",
        order_id: "",
        member_name: "",
        member_id: "",
        member_phone: "",
        limit: 50,
        offset: 0,
        page: 1,
      };

      this.execSearch();
    },
    setSearchPayload: async function(viewListCount, page) {
      this.searchPayload.limit = viewListCount;
      this.searchPayload.page = page;
      let offset =
        this.searchPayload.limit * this.searchPayload.page -
        this.searchPayload.limit;
      this.searchPayload.offset = offset;
      await this.execSearch();
    },
    getProductList: async function() {
      try {
        let result = await M.api(M.entry("/get/mileage"));
        for (let i = 0; i < result.length; i++) {
          let setData = {
            text: "포인트상품 " + result[i].price + "원",
            value: result[i].product_no,
          };
          this.productItems.push(setData);
        }
      } catch (e) {
        alert("상품명 리스트 조회 실패했습니다");
      }
    },
  },
  mixins: [CommonMixin],
  created: async function() {
    //await this.execSearch();
  },
  mounted: async function() {
    const today = dayjs();
    this.searchPayload.paid_from = today
      .subtract("1", "month")
      .format("YYYY-MM-DD");
    this.searchPayload.paid_to = today.format("YYYY-MM-DD");
    // await this.getProductList();
    setTimeout(() => {
      this.$parent.loadCompleted();
    }, 1000);
  },
};
</script>
